import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconSirenOff = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={25}
      fill="none"
      viewBox="0 0 24 25"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <g clipPath="url(#clip0_4904_59454)">
        <path
          d="M4.14285 18.5201H19.8571"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.8571 18.5202C19.8571 18.5202 18.2857 17.1521 18.2857 12.2345C18.2857 8.30596 15.6017 4.82996 12 4.82996C8.39828 4.82996 5.71428 8.30596 5.71428 12.2345C5.71428 17.1782 4.14285 18.5202 4.14285 18.5202"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5714 21.6631C13.5714 22.0799 13.4059 22.4796 13.1112 22.7743C12.8165 23.069 12.4168 23.2345 12 23.2345C11.5832 23.2345 11.1835 23.069 10.8888 22.7743C10.5941 22.4796 10.4286 22.0799 10.4286 21.6631"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 4.82991V2.80591"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
};
